import React, { useCallback, FC } from 'react'
import { useMount } from 'react-nb-hooks'
import { Grid, Segment } from 'semantic-ui-react'
import { LKHeader } from 'loankeeper-common/components'
import { TwilightProvider } from 'loankeeper-common/components/hocs/Twilight'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'
import container from './container'
import { translate } from '../../helpers'
import AccSearchAccNo from './AccSearchAccNo'
import AccSearchAccTypes from './AccSearchAccTypes'
import AccSearchBalCodeId from './AccSearchBalCodeId'
import AccSearchCurrencies from './AccSearchCurrencies'
import AccSearchNodes from './AccSearchNodes'
import AccSearchPersonalNo from './AccSearchPersonalNo'
import AccSearchStatus from './AccSearchStatus'
import AccSearchSubmitButton from './AccSearchSubmitButton'
import AccSearchTitle from './AccSearchTitle'
import AccSearchHint from './AccSearchHint'
import { AccSearchPanelProps } from '../components.type'

const AccSearchPanel: FC<AccSearchPanelProps> = ({ accNo, submit, handleSubmit, selector }) => {
  useMount(() => {
    const timeout = setTimeout(() => {
      if (accNo) {
        submit()
      }
    })

    return () => {
      clearTimeout(timeout)
    }
  })

  const onSubmit = useCallback(
    (e) => {
      e.stopPropagation()
      handleSubmit(e)
    },
    [handleSubmit],
  )

  return (
    <form className="search-form-container" onSubmit={onSubmit}>
      <TwilightProvider wrapperHeight="202px">
        <Segment style={{ padding: '5px 0px', zIndex: 99999999999999 }}>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate('lbl_onwertitle')}
                </Grid.Column>

                <Grid.Column width={4} textAlign="right">
                  <AccSearchTitle />
                </Grid.Column>

                <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                  <LKHeader as="h5" content={translate('lbl_ccy')} />
                </Grid.Column>

                <Grid.Column width={4}>
                  {/* @ts-ignore */}
                  <AccSearchCurrencies selector={selector} />
                </Grid.Column>

                <Grid.Column width={3} textAlign="center" verticalAlign="middle">
                  <AccSearchStatus selector={selector} />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate('lbl_accno')}
                </Grid.Column>

                <Grid.Column width={2} textAlign="right">
                  <AccSearchBalCodeId />
                </Grid.Column>

                <Grid.Column width={2} textAlign="right">
                  <AccSearchAccNo />
                </Grid.Column>

                <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                  <LKHeader as="h5" content={translate('lbl_acc_type')} />
                </Grid.Column>

                <Grid.Column width={4}>
                  {/* @ts-ignore */}
                  <AccSearchAccTypes selector={selector} />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                  {translate('lbl_clientid')}
                </Grid.Column>

                <Grid.Column width={4} textAlign="right">
                  <AccSearchPersonalNo />
                </Grid.Column>

                <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                  <LKHeader as="h5" content={translate('lbl_node')} />
                </Grid.Column>

                <Grid.Column width={4}>
                  <AccSearchNodes />
                </Grid.Column>

                <Grid.Column width={1} />

                <Grid.Column width={2} textAlign="center">
                  <AccSearchSubmitButton />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column>
                  <AccSearchHint />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </TwilightProvider>
    </form>
  )
}

export default container(AccSearchPanel)
